module.exports = __webpack_public_path__ + "static/media/ATH-ALTERNATIVE.cf8d05f8.gif";